import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import '../../styles/CuadroResumen.scss';
import appStore from '../../stores/AppStore';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function PaginadorComponent(props) {
  const classes = useStyles();
  const paginas = Math.ceil(appStore.totalRegistrosSolicitudes / appStore.PAGE_SIZE);
  return (
    <div className="paginadorRipley">
      <div className={classes.root}>
        <Pagination count={paginas} color="primary" onChange={props.onChange} page={props.paginaActiva} />
      </div>
    </div>
  );
}
